import hyperdom from 'hyperdom'
import Results from './results.jsx'
import Criteria from './criteria.jsx'
import * as gtmDataLayer from '../analytics/gtm/dataLayer.js'

export default class Search {
  constructor (model, api) {
    this.model = model
    this.criteria = new Criteria(model, api)
    this.results = new Results(model)
  }

  onadd () {
    gtmDataLayer.activateOptimize()
  }

  onupdate () {
    gtmDataLayer.activateOptimize()
  }

  render () {
    const model = this.model
    const promisedFlights = model.promisedFlights

    if (promisedFlights.type !== 'explore') return

    const results = this.results
    const criteria = this.criteria
    const search = {
      loading: () => {return <div></div>},
      criteria: criteria.render.bind(criteria),
      results: results.render.bind(results),
      noResults: results.noResults.bind(results),
      selected: results.selected.bind(results),
    }

    return search[promisedFlights.searchMode]()
  }
}
